const accordions = document.querySelectorAll('.accordion .accordion-content');
const images = document.querySelectorAll('.accordion .accordion__images-image');

function handleImageDisplay(event) {
  const accordionId = event.currentTarget.id;

  images.forEach((img) => {
    const isThisImageTarget = img.dataset.target === `#${accordionId}`;
    isThisImageTarget ? img.classList.add('show') : img.classList.remove('show');
  });
}

accordions.forEach((accordion) => {
  accordion.addEventListener('click', handleImageDisplay);
});